import { render } from "./LoadScreen.vue?vue&type=template&id=fe84e4d6&scoped=true"
import script from "./LoadScreen.vue?vue&type=script&lang=js"
export * from "./LoadScreen.vue?vue&type=script&lang=js"

import "./LoadScreen.vue?vue&type=style&index=0&id=fe84e4d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe84e4d6"]])

export default __exports__